import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Divider } from '@vinted/web-ui';
import LanguageSelector from 'components/LanguageSelector';
import SeparatedList from 'components/SeparatedList';
import { transformCatalogDtoList } from 'data/transformers/catalog';
import { transformUserDto } from 'data/transformers/user';
import * as sessionSelectors from 'state/session/selectors';
import AccountLinks from './AccountLinks';
import CategoriesSection from './CategoriesSection';
import LoginSection from './LoginSection';
import OtherSection from './OtherSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SideNavigation = _ref => {
  let {
    catalogTree,
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const userDto = useSelector(sessionSelectors.getUser);
  const transformedUser = useMemo(() => userDto ? transformUserDto(userDto) : null, [userDto]);
  const transformedTree = useMemo(() => transformCatalogDtoList(catalogTree), [catalogTree]);
  return /*#__PURE__*/_jsxs(SeparatedList, {
    separator: /*#__PURE__*/_jsx(Divider, {}),
    children: [/*#__PURE__*/_jsx(LoginSection, {
      user: transformedUser
    }), /*#__PURE__*/_jsx(CategoriesSection, {
      categories: transformedTree
    }), userDto && /*#__PURE__*/_jsx(AccountLinks, {
      userId: userDto.id
    }), /*#__PURE__*/_jsx(LanguageSelector, {}), /*#__PURE__*/_jsx(OtherSection, {
      impressumUrl: impressumUrl,
      isBusinessAccountLinksVisible: isBusinessAccountLinksVisible
    })]
  });
};

export default SideNavigation;